import React from "react";

const OpenLockIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_816_1798)">
    <path d="M8.4375 6.5625V4.21875C8.4375 3.47283 8.73382 2.75746 9.26126 2.23001C9.78871 1.70257 10.5041 1.40625 11.25 1.40625C11.9959 1.40625 12.7113 1.70257 13.2387 2.23001C13.7662 2.75746 14.0625 3.47283 14.0625 4.21875V6.5625M2.34375 13.5938H8.90625C9.27921 13.5938 9.6369 13.4456 9.90062 13.1819C10.1643 12.9181 10.3125 12.5605 10.3125 12.1875V7.96875C10.3125 7.59579 10.1643 7.2381 9.90062 6.97438C9.6369 6.71066 9.27921 6.5625 8.90625 6.5625H2.34375C1.97079 6.5625 1.6131 6.71066 1.34938 6.97438C1.08566 7.2381 0.9375 7.59579 0.9375 7.96875V12.1875C0.9375 12.5605 1.08566 12.9181 1.34938 13.1819C1.6131 13.4456 1.97079 13.5938 2.34375 13.5938Z" stroke="#2158D0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_816_1798">
    <rect width="15" height="15" fill="white"/>
    </clipPath>
    </defs>
    </svg>  
  );
};

export default OpenLockIcon;
